import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ThemeLayoutService } from '@services/theme-layout.service';
import { AuthenticationService } from '@app/core/auth';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-header-left',
  imports: [MatButtonModule, MatIconModule],
  template: `
    @let user = authService.currentUser();
    <div class="nav-left">
      @if (showToggleMenu) {
        <button id="step-menu" mat-icon-button (click)="toggleMenu()" aria-label="Alternar menú">
          <mat-icon>menu</mat-icon>
        </button>
      }

      <p class="nav-left__company">
        {{ user?.user?.company?.number }} - {{ user?.user?.company?.name }}
      </p>
    </div>
  `,
  styles: [
    `.nav-left {
        display: flex;
        align-items: center;
        gap: 1rem;

        &__company {
          font-size: clamp(1rem, 2.5vw, 1.25rem);
          color: var(--primary-500);
          font-weight: 600;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
       `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavLeftComponent {
 private readonly themeService = inject(ThemeLayoutService);
  readonly authService = inject(AuthenticationService);

  readonly showToggleMenu = true;

  toggleMenu(): void {
    this.themeService.toggleSideDrawer();
  }
}
